import React, { Fragment } from 'react';
import './Hero.scss';
import { withContent } from '../../hoc/withContext';
import { IContent, IProduct } from '../../types';
import { connect } from 'react-redux';
import HeroBlock from './HeroBlock';

interface HeroProps {
  context?: IContent;
  products?: IProduct[];
}

const Hero: React.FC<HeroProps> = ({ context }) => {
  const { hero, config, global } = context;

  const [firstBlock, ...otherBlocks] = hero;

  const classes = ['hero__block__wrapper'];

  if (otherBlocks && otherBlocks.length > 1) {
    classes.push('hero__block__multiple');
  }

  return (
    <div className="hero">
      <HeroBlock
        Tag="h1"
        imageName={firstBlock.bg}
        mobileImage={firstBlock.mobileBg}
        {...(firstBlock.tabletBg && { tabletImage: firstBlock.tabletBg })}
        title={firstBlock.title}
        subtitle={firstBlock.subtitle}
        cta={{
          productId: firstBlock.cta.productId,
          country_code: config.country_code,
          text: global.buy,
          tracking: firstBlock.cta.tracking,
          redirectionType: firstBlock.cta.redirectionType,
          redirectionValue: firstBlock.cta.redirectionValue
        }}
      />
      <div className={classes.join(' ')}>
        {otherBlocks.map((block, index) => {
          return (
            <Fragment key={`block-${index}`}>
              <HeroBlock
                imageName={block.bg}
                mobileImage={block.mobileBg}
                {...(block.tabletBg && { tabletImage: block.tabletBg })}
                title={block.title}
                subtitle={block.subtitle}
                cta={{
                  productId: block.cta.productId,
                  country_code: config.country_code,
                  text: global.buy,
                  tracking: block.cta.tracking,
                  redirectionType: block.cta.redirectionType,
                  redirectionValue: block.cta.redirectionValue
                }}
                legal={
                  block.legal && block.legal.text !== ''
                    ? block.legal
                    : undefined
                }
              />
            </Fragment>
          );
        })}
      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  products: state.products.data
});

export default connect(mapStateToProps)(withContent(Hero));
